module.exports = __webpack_public_path__ + "img/899.35879e0a.png";